import template from './component.tpl.html';
import AlMediaManagerDirectoryContentListing from './controller';

angular
    .module('festzelt-os.modules.media')
    .component('alMediaManagerDirectoryContentListing', {
        bindings: {
            directoryUuid: '<',
            showHiddenFiles: '<',
            enableFileSelection: '<',
            onFileSelection: '&',
            preSelectedFileUuid: '<'
        },
        controller: AlMediaManagerDirectoryContentListing,
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/media/components/al-media-manager/sub-components/directory-content-listing/component.js